import React from 'react';
import { PricesProvider } from '@fff-web/fff-payments';
import { trackPageLoad } from '@fff-web/fff-analytics';
import { ReactivateMyMembershipProvider } from '../../utils/ContextProviders/ReactivateContext';
import { getQueryParam } from '../MyAccount/utils/url';
import ReactivateMembershipV2 from '../ReactivateMembershipV2';
import {
  COUPON_CODE_QUERY_PARAM,
  EXPIRED_SUBSCRIPTION_STATE,
  LOGGED_OUT_STATE,
  PAGE_LOAD_EVENT_TITLE,
} from '../constants';

const ReactivateMyMembership = ({ location, history }) => {
  trackPageLoad({
    trackName: PAGE_LOAD_EVENT_TITLE,
    properties: {
      coupon_code: getQueryParam(COUPON_CODE_QUERY_PARAM),
      subscription_state: EXPIRED_SUBSCRIPTION_STATE,
      login_state: LOGGED_OUT_STATE,
    },
  });
  return (
    <ReactivateMyMembershipProvider>
      <PricesProvider>
        <ReactivateMembershipV2 location={location} history={history} />
      </PricesProvider>
    </ReactivateMyMembershipProvider>
  );
};

export default ReactivateMyMembership;
